import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentLines = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 1.5h4.5L9.75 3.75V10.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-9A.75.75 0 0 1 3 1.5Z",
		stroke: "currentColor",
		strokeWidth: .75,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 5.25h3M4.5 6.75h3M4.5 8.25h3",
		stroke: "currentColor",
		strokeWidth: .75,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgDocumentLines;
